import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ApiError } from '@/lib/api';
import { useLocalePath } from '@/lib/locale';
import styles from './Feedback.module.css';

export function PageLoader() {
  const { t } = useTranslation();
  return (
    <div className={styles.loader} role="status">
      <span className={styles.spinner} aria-hidden="true" />
      <span className="visually-hidden">{t('common.loading')}</span>
    </div>
  );
}

export function NotFound() {
  const { t } = useTranslation();
  const to = useLocalePath();
  return (
    <section className={`container ${styles.message}`}>
      <title>{`${t('common.notFoundTitle')} - CEO`}</title>
      <p className={styles.code}>404</p>
      <h1>{t('common.notFoundTitle')}</h1>
      <p>{t('common.notFoundText')}</p>
      <Link to={to('/')} className={styles.button}>
        {t('common.backHome')}
      </Link>
    </section>
  );
}

/** Route error boundary: 404s from loaders render NotFound, anything else a retry screen. */
export function RouteError() {
  const error = useRouteError();
  const { t } = useTranslation();
  const notFound =
    (isRouteErrorResponse(error) && error.status === 404) ||
    (error instanceof ApiError && error.status === 404);
  if (notFound) return <NotFound />;
  if (import.meta.env.DEV) console.error(error);
  return (
    <section className={`container ${styles.message}`}>
      <h1>{t('common.error')}</h1>
      <button type="button" className={styles.button} onClick={() => window.location.reload()}>
        {t('common.retry')}
      </button>
    </section>
  );
}
